import React, { useEffect, useRef, useState } from "react";
import "../assets/css/About.css";


// Replace these imports with your real image paths
import founderImg from "../assets/about-imgs/indrajit-sir.jpg";
import heroImg from "../assets/about-imgs/indrajit-sir.jpg";
import stat from "../assets/about-imgs/stat.png";



const About = () => {


    const statsRef = useRef(null);
    const [animationDone, setAnimationDone] = useState(false);

    const stats = [
        { label: "Trained Professionals", value: 2000,icon: stat },
        { label: "Franchise Districts", value: 20,icon: stat },
        { label: "Talukas Covered", value: 200,icon: stat },
        { label: "Events & Site Visits", value: 1000,icon: stat },
        { label: "Satisfaction Rate", value: 95,icon: stat },
        { label: "Qualified Leads Generated", value: 3000,icon: stat }


    ];

    const [count, setCount] = useState(stats.map(() => 0));

    useEffect(() => {
        const handleScroll = () => {
            if (!statsRef.current || animationDone) return;

            const top = statsRef.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;

            if (top < windowHeight - 100) {
                startCounter();
                setAnimationDone(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [animationDone]);

    const startCounter = () => {
        stats.forEach((stat, index) => {
            let start = 0;
            const end = stat.value;
            const duration = 3000;
            const increment = end / (duration / 16);

            const counter = setInterval(() => {
                start += increment;

                setCount(prev => {
                    const updated = [...prev];
                    updated[index] = Math.floor(start);
                    return updated;
                });

                if (start >= end) clearInterval(counter);
            }, 16);
        });
    };

    return (
        <main className="about-container">
            {/* HERO */}
            <section className="about-hero">
                <div className="about-hero-overlay">
                    <div className="about-hero-content">
                        <h1 className="about-hero-title">Samriddhi Gurukul</h1>
                        <p className="about-hero-sub">
                            A new-age Gurukul for real estate professionals — learn practical skills, build
                            credibility, and grow your business with a community that cares.
                        </p>
                        <div className="about-hero-ctas">
                            <button className="about-btn about-btn-primary">Explore Courses</button>
                            <button className="about-btn about-btn-ghost">Become a Partner</button>
                        </div>
                    </div>

                    <div
                        className="about-hero-visual"
                        role="img"
                        aria-label="Gurukul learning image"
                        style={{ backgroundImage: `url(${heroImg})` }}
                    />
                </div>
            </section>

            {/* VISION + MISSION */}
            <section className="about-vision-mission">
                <div className="about-grid">
                    <div className="about-text-card">
                        <h2 className="about-section-title">Our Vision</h2>
                        <p className="about-text">
                            To empower every real estate professional in India with practical knowledge,
                            ethical values and future-ready business skills — creating a nation of credible,
                            confident channel partners.
                        </p>
                    </div>

                    <div className="about-text-card">
                        <h2 className="about-section-title">Our Mission</h2>
                        <p className="about-text">
                            Build a nationwide training ecosystem that uplifts careers, accelerates business
                            growth, and strengthens the real estate ecosystem through hands-on training,
                            builder-networking, and continuous mentorship.
                        </p>
                    </div>
                </div>
            </section>

            {/* STATS */}
            <section className="about-stats" ref={statsRef}>

                <h3 className="about-stats-title">Gurukul Network — By the numbers</h3>
                <div className="about-stats-grid">
                    {stats.map((stat, i) => (
                        <div key={i} className="about-stat-card" tabIndex="0" aria-label={`${count[i]} ${stat.label}`}>
                            <img src={stat.icon} alt="" className="about-stat-icon" />
                            <div className="about-stat-value">{count[i]}</div>
                            <div className="about-stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* FOUNDER */}
            <section className="about-founder">
                <div className="about-founder-inner">
                    <div className="about-founder-imgwrap">
                        <img className="about-founder-img" src={founderImg} alt="Indrajit Patil - Director" />
                    </div>

                    <div className="about-founder-text">
                        <h4 className="about-founder-title">Meet the Founder</h4>
                        <h2 className="about-founder-name">Indrajit Patil</h2>
                        <p className="about-founder-role">Director</p>

                        <p className="about-founder-bio">
                            Indrajit brings years of experience in real estate operations and training. He started
                            Samriddhi Gurukul to create a reliable pathway for channel partners to learn,
                            network and prosper. His practical approach blends on-field experience with
                            repeatable systems that deliver growth.
                        </p>

                        <div className="about-founder-cta">
                            <button className="about-btn about-btn-primary">Apply for Training</button>
                            <button className="about-btn about-btn-ghost">Contact the Team</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA / Closing */}
            <section className="about-cta-strip">
                <div className="about-cta-inner">
                    <h3 className="about-cta-title">Ready to transform your real estate career?</h3>
                    <div>
                        <button className="about-btn about-btn-cta">Register Now</button>
                        <button className="about-btn about-btn-ghost">Franchise Enquiry</button>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default About;
